import { useQuery } from '@tanstack/react-query'
import { getAgendaByIdService } from '@/services/agendas'

export const agendaDetailsQueryKey = (agendaId: string) => ['agendas', agendaId]

export const useAgendaDetails = (agendaId: string) =>
  useQuery({
    queryKey: agendaDetailsQueryKey(agendaId),
    queryFn: () => getAgendaByIdService(agendaId),
  })
